module.exports = __webpack_public_path__ + "img/screen_driver.184364e6.png";